import React from 'react';
import IconPriceTag from '@spothero/icons/price-tag';
export const BenefitMessage = ({ percentLowerPrice, iataCode, }) => {
    return (<div className="BenefitMessage" data-testid="BenefitMessage">
            <span className="BenefitMessage-text">
                <IconPriceTag className="BenefitMessage-icon"/> Price is lower
                than {percentLowerPrice}% of {iataCode} spots on SpotHero
            </span>
        </div>);
};
export default BenefitMessage;
